import Link from 'next/link';
import { FC, useMemo, useState } from 'react';
import { usePopper } from 'react-popper';
import { replaceOrAddLocale, useLocale } from '../../helpers/LangHelper';
import { BusinessHubMenuItemType } from '../../types/BusinessIndustries';
import BusinessHubMenuDropdown from './business-hub-menu-dropdown';
import styles from './business-hub-menu-item.module.scss';
import { useRouter } from 'next/router';
import classNames from 'classnames';

export interface BusinessHubMenuItemProps extends BusinessHubMenuItemType {}

export const BusinessHubMenuItem: FC<BusinessHubMenuItemProps> = (props) => {
    const { name, url, locale: itemLocale, childrenItems } = props;

    const { locale } = useLocale();
    const [referenceElement, setReferenceElement] = useState<any>(null);
    const [popperElement, setPopperElement] = useState<any>(null);
    const route = useRouter();

    const isActive = useMemo(() => {
        if (route.isFallback) return false;

        const itemUrl = replaceOrAddLocale(url || '', locale);
        const pageSlug = route.query.slug && Array.isArray(route.query.slug) ? `/${route.query.slug.join('/')}` : route.query.slug;

        return pageSlug === itemUrl;
    }, [route]);

    const { styles: popperStyles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 15],
                },
            },
            { name: 'eventListeners', enabled: false },
        ],
        placement: 'bottom-start',
        strategy: 'absolute',
    });

    if (itemLocale?.length && !itemLocale.includes(locale)) {
        return null;
    }

    return (
        <div ref={setReferenceElement} className={styles.container}>
            {url ? (
                <Link href={replaceOrAddLocale(url || '', locale)} className={classNames(styles.menuItem, { [styles.active]: isActive })} aria-label={name}>
                    {name}
                </Link>
            ) : (
                <div className={styles.menuItem}>{name}</div>
            )}
            {childrenItems ? (
                <BusinessHubMenuDropdown
                    ref={setPopperElement}
                    items={childrenItems.filter((child) => {
                        if (!child.locale) return true;
                        return child.locale.includes(locale);
                    })}
                    popperStyles={popperStyles}
                    attributes={attributes}
                />
            ) : null}
        </div>
    );
};
